import { render, staticRenderFns } from "./MopSortButton.vue?vue&type=template&id=c3dbdfec&scoped=true&"
import script from "./MopSortButton.vue?vue&type=script&lang=js&"
export * from "./MopSortButton.vue?vue&type=script&lang=js&"
import style0 from "./MopSortButton.vue?vue&type=style&index=0&id=c3dbdfec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dbdfec",
  null
  
)

export default component.exports